import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { firebase } from '../../../firebase';
import {
  default as config,
  DOCUMENTS_PAGE_SIZE
} from '../../../constants/constants';
import ImageLoader from '../../../components/ImageLoader';
import {
  OverlayTrigger,
  Popover,
  Row,
  Col,
  Button,
  Image,
  ProgressBar,
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Truncate from 'react-truncate';
import waveform from '../../../images/waveform.png';
import play from '../../../images/play.png';
import { getProgress, getDuration } from '../../../utils/utils';
import imageNotAvailable from '../../../images/image_not_available.png';
import ShowMoreText from 'react-show-more-text';
import AddToPlaylistModal from '../../documents/components/AddToPlaylistModal';
import {
  updateDocument,
  updateUserFields,
  fetchUserFields,
  setListeningToDocument,
  setPlaybackPlaylists,
  setPlayingDocumentId,
  fetchLast5ListenedDocuments,
  increaseDiscoveryDocumentsPage,
  resetDiscoveryDocumentsSearchValue,
  resetDiscoveryDocumentsPage,
  updateDiscoveryDocumentsSearchValue
} from '../../../redux/actions/app-actions';
import moment from 'moment';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import logo from '../../../images/inflo_logo.png';
import {
  setPlayerDocument,
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setShowSkipButton,
  setPlayResource,
  setIsPaused,
  resetProgress,
  setAllDocuments,
  setAllSeasons,
  setFromSkip,
  setFullSerialDocuments,
  setSeason,
  setFeedUrl,
  setStoreProgress,
  setNewDocumentInLast5,
  setPodcastSeasons
} from '../../../redux/actions/player-actions';
import eventBus from '../../../components/EventBus';
import TablePodcastSkeletonLoader from '../../../components/ui/skeleton/TablePodcastSkeletonLoader';
import PodcastDocumentHeaderLoader from '../../../components/ui/skeleton/PodcastDocumentHeaderLoader';
import { scrollToTop } from '../../../utils/scrollToUtil';
import { fetchDocuments } from '../../../apis/documents';
import { DocumentSortOptionsEnum } from '../../documents/types/types';
import RefreshButton from '../../../components/ui/button/RefreshButton';
import InfiniteScrollWrapper from '../../dashboard/components/shared/InfiniteScrollWrapper';
import { hasMoreDocumentsCheck } from '../../../utils/hasMoreCheckUtil';
import { Input } from '../../../components/ui/input/Input';
import debounce from 'debounce';
import {
  getDocumentsWithUniqueIdentifier,
  getOnlyFullDocuments
} from '../../dashboard/utils/helpers';

class PodcastWithDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingDocuments: true,
      addToPlaylist: false,
      documentoAdd: null,
      scrollY: 0,
      heightNav: 0,
      widthChild: 0,
      fromls: false,
      error: null,
      summary: '',
      podcastType: '',
      seasonCount: 0,
      playSerial: false,
      playerKey: 0,
      newDocumentInLast5: false,
      selectSeason: false,
      goToNextSeason: false,
      showPlayButton: false,
      isForceReloadEnabled: false,
      hasMoreDocuments: true,
      fetchingMoreDocuments: false,
      isPodcastUnavailable: false
    };

    this.player = React.createRef();
    this.myNav = React.createRef();
    this.mediaChild = React.createRef();
    this.debouncedSearch = debounce(this.searchDocuments, 300);
  }

  componentDidMount() {
    scrollToTop();
    if (this.myNav.current !== null && this.mediaChild.current !== null) {
      this.setState({
        heightNav: this.myNav.current.offsetHeight,
        widthChild: this.mediaChild.current.offsetWidth
      });
    }
    //window.addEventListener('beforeunload', this.saveMediaState);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.updateSize);

    eventBus.on('onProgress', (document) => this.handleProgress(document));
    eventBus.on('onLoadSeason', (data) => this.onLoadSeason(data.season));
  }

  componentWillUnmount() {
    clearTimeout(this.interval);
    this.props.dispatch(setAllDocuments([]));
    this.props.dispatch(setFeedUrl(null));
    this.setState({
      loader: false
    });
    window.removeEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.updateSize);
    eventBus.remove('onProgress');
    this.debouncedSearch.clear();
  }

  onScroll = () => {
    const scrollY = window.scrollY;
    this.setState({
      scrollY: scrollY
    });
  };

  updateSize = () => {
    if (this.myNav.current !== null && this.mediaChild.current !== null) {
      this.setState({
        heightNav: this.myNav.current.offsetHeight,
        widthChild: this.mediaChild.current.offsetWidth,
        scrollY: window.scrollY
      });
    }
  };

  componentWillMount() {
    this.props.dispatch(resetDiscoveryDocumentsPage());
    this.props.dispatch(resetDiscoveryDocumentsSearchValue());
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(fetchLast5ListenedDocuments(token));
        this.props.dispatch(fetchUserFields(token));
        fetchDocuments(
          token,
          this.props.feedUrl,
          this.props.podcastId,
          '',
          0,
          50,
          this.props.season,
          DocumentSortOptionsEnum.DEFAULT,
          undefined,
          undefined,
          false
        )
          .then((res) => {
            const { data } = res;
            if (data.status == 'empty' || data.status == 'error') {
              this.props.dispatch(setAllDocuments(data.episodes));
              this.props.dispatch(setFeedUrl(this.props.feedUrl));
              this.props.dispatch(setAllSeasons(data.allSeasons));
              this.setState({
                fetchingDocuments: false,
                summary: data.podcastDescription,
                podcastType: data.type,
                seasonCount: data.seasonCount
              });

              if (data.status === 'error') {
                this.setState({ isPodcastUnavailable: true });
              } else {
                this.setState({ hasMoreDocuments: false });
              }

              this.setState({ hasMoreDocuments: false });
            } else {
              const documents = getDocumentsWithUniqueIdentifier(data.episodes);

              if (documents.length === 0) {
                this.setState({ hasMoreDocuments: false });
              }
              const hasMoreDocuments = hasMoreDocumentsCheck(documents);
              this.setState({ hasMoreDocuments: hasMoreDocuments });

              this.props.dispatch(setAllDocuments(documents));
              this.props.dispatch(setFeedUrl(this.props.feedUrl));
              this.props.dispatch(setAllSeasons(data.allSeasons));
              this.props.dispatch(setPodcastSeasons(data.allSeasons));

              let arrayFull = this.getOnlyFullDocuments();
              if (arrayFull.length > 0) {
                this.setState({ showPlayButton: true });
              } else {
                this.setState({ showPlayButton: false });
              }

              this.setState({
                fetchingDocuments: false,
                summary: data.podcastDescription,
                podcastType: data.type,
                seasonCount: data.seasonCount
              });
            }
            this.props.dispatch(
              setFullSerialDocuments(this.getOnlyFullDocuments())
            );
          })
          .catch((err) => {
            console.error(err);
            this.props.dispatch(setAllDocuments([]));
            this.props.dispatch(setAllSeasons([]));
            this.props.dispatch(setPodcastSeasons([]));
            this.setState({
              fetchingDocuments: false,
              podcastType: '',
              seasonCount: '0',
              isPodcastUnavailable: true,
              hasMoreDocuments: false
            });
          })
          .finally(() => {
            this.setState({ fetchingMoreDocuments: false });
          });
      });
    }
  }

  doNothing = () => {};

  formatHeaderdocumentab = (cell, row) => (
    <div className="thumbnail-container">
      {row.isNew && (
        <div
          style={{ width: '40%', height: '70%' }}
          className="new-document-item"
        >
          <span>New</span>
        </div>
      )}
      {typeof this.props.playingDocumentId === 'number' ? (
        <div>
          <div
            className={`thumbnail-header ${
              this.props.playingDocumentId === parseInt(row.id, 10)
                ? 'playing'
                : ''
            }`}
          >
            <ImageLoader width="60px" height="60px" src={cell} />
          </div>
          {this.props.playingDocumentId !== parseInt(row.id, 10) ? (
            <div
              className="play-thumbnail"
              onClick={() => this.onRowClickDocument(row, false, true)}
            >
              <Image width={32} height={35} src={play} />
            </div>
          ) : this.props.playingDocumentId === parseInt(row.id, 10) &&
            this.props.isPaused ? (
            <div
              className="play-icon"
              onClick={() => this.onRowClickDocument(row, false, true)}
            >
              <Image width={32} height={35} src={play} />
            </div>
          ) : (
            this.props.playingDocumentId === parseInt(row.id, 10) && (
              <div className="wave-icon">
                <Image width={45} height={40} src={waveform} />
              </div>
            )
          )}
        </div>
      ) : (
        <div>
          <div
            className={`thumbnail-header ${
              this.props.playingDocumentId === row.id ? 'playing' : ''
            }`}
          >
            <ImageLoader width="60px" height="60px" src={cell} />
          </div>
          {this.props.playingDocumentId !== row.id ? (
            <div
              className="play-thumbnail"
              onClick={() => this.onRowClickDocument(row, false, true)}
            >
              <Image width={32} height={35} src={play} />
            </div>
          ) : this.props.playingDocumentId === row.id && this.props.isPaused ? (
            <div
              className="play-icon"
              onClick={() => this.onRowClickDocument(row, false, true)}
            >
              <Image width={32} height={35} src={play} />
            </div>
          ) : (
            this.props.playingDocumentId === row.id && (
              <div className="wave-icon">
                <Image width={45} height={40} src={waveform} />
              </div>
            )
          )}
        </div>
      )}
    </div>
  );

  sortByName(a, b, order) {
    a = `${a.documentName}`;
    b = `${b.documentName}`;
    if (order === 'desc') {
      return a.localeCompare(b);
    } else {
      return b.localeCompare(a);
    }
  }

  sortDatedocumentab = (a, b, order) => {
    let a_ = a.releaseDate != '' ? a.releaseDate : 0;
    let b_ = b.releaseDate != '' ? b.releaseDate : 0;
    if (order === 'desc') {
      return moment(b_) - moment(a_);
    }
    return moment(a_) - moment(b_);
  };

  formatdocumentab = (cell, row) => (
    <div className="document">
      <p style={{ color: '#929394', fontWeight: '600' }}>
        {row.season === config.unknownSeason
          ? 'Season unknown' + ','
          : row.season !== -1 && row.season !== 1000
          ? 'Season ' + row.season + ','
          : ''}
        &nbsp;
        {row.documentType === 'full'
          ? 'Document'
          : row.documentType === 'trailer'
          ? 'Trailer'
          : row.documentType === 'bonus'
          ? 'Bonus'
          : ''}
        &nbsp;
        {row.numOfDocument !== 0 && row.numOfDocument !== 1000
          ? row.numOfDocument
          : row.documentType === 'full' &&
            row.numOfDocument === 1000 &&
            row.numToShow !== 0
          ? row.numToShow
          : row.numOfDocument === 1000 && row.numToShow !== 0
          ? row.numToShow
          : ''}
      </p>
      <p>{(row?.document?.name)}</p>
      <ProgressBar now={getProgress(row.progress, getDuration(row.duration))} />
    </div>
  );

  formatAdddocumentoPlaylist = (cell, row) => {
    return (
      <Button
        bsClass="custom-button"
        onClick={() => this.addToPlaylistHandler(true, row)}
      >
        <i className="fa fa-plus"></i>
      </Button>
    );
  };

  addToPlaylistHandler = (value, document) => {
    this.setState({ addToPlaylist: value, documentoAdd: document });
  };

  onRowClickDocument = (row, showSkipButton = false, isSinglePlay = false) => {
    let currentId = row.id;
    let currentIndex = 0;
    let fullDocuments =
      this.props.fullDocuments !== null ? this.props.fullDocuments : [];
    let allSeasons =
      this.props.allSeasons !== null ? this.props.allSeasons : [];
    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');
    this.props.dispatch(setPlayResource('discover'));
    //check if first document of first season and check if last document of last season
    //check if first document of first season and check if last document of last season
    if (typeof currentId === 'string' && currentId.startsWith('0')) {
      //non listened to document means that in fullDocuments list we have a null value for id
      currentIndex = fullDocuments.findIndex((epi) => epi.id === null);
      if (currentIndex === 0 && row.season === 1) {
        this.props.dispatch(setDisableSkipBackButton(true));
      }
      if (
        currentIndex === fullDocuments.length - 1 &&
        ((indexForUnknownSeason !== -1 &&
          row.season === allSeasons.length - 1) ||
          row.season === allSeasons.length)
      ) {
        this.props.dispatch(setDisableSkipAheadButton(true));
      }
    } else {
      currentIndex = fullDocuments.findIndex((epi) => epi.id === row.id);
      if (currentIndex === 0 && row.season === 1) {
        this.props.dispatch(setDisableSkipBackButton(true));
      }
      if (
        currentIndex === fullDocuments.length - 1 &&
        ((indexForUnknownSeason !== -1 &&
          row.season === allSeasons.length - 1) ||
          row.season === allSeasons.length)
      ) {
        this.props.dispatch(setDisableSkipAheadButton(true));
      }
    }
    let userFields = this.props.userFields;
    let checkedAutoPlay = userFields?.auto_play_serial
      ? 'checked'
      : 'unchecked';
    let checkedAutoPlayDontAsk = userFields?.auto_play_serial_dont_ask
      ? 'checked'
      : 'unchecked';
    var checked1 = false;
    var checked2 = false;
    if (
      isSinglePlay &&
      row.documentType === 'full' &&
      (userFields?.auto_play_serial_dont_ask === undefined ||
        !userFields?.auto_play_serial_dont_ask) &&
      (sessionStorage.getItem('auto_play_serial') === null ||
        !sessionStorage.getItem('auto_play_serial'))
    ) {
      this.setState({ playSerial: true });
      this.props.dispatch(setDisableSkipAheadButton(false));
      this.props.dispatch(setDisableSkipBackButton(false));
      swal({
        imageUrl: logo,
        title: '<div class="titleModal">Auto Play Mode</div>',
        html:
          '<p class="contentModal">Auto Play each document in order?<label class="switch">' +
          `<input type="checkbox" id="autoplay" name="autoplay" ${checkedAutoPlay}/>` +
          '<span class="slider round"></span>' +
          '</label></p>' +
          `<p><input type="checkbox" class="autoplay" id="autoplaydontask" name="autoplaydontask" ${checkedAutoPlayDontAsk}>` +
          '<label class="autoplaylabel" for="autoplaydontask" id="autoplaydontasklabel"> Do not ask again</label><br></p>',
        showCancelButton: true,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#E31690'
      })
        .then((result) => {
          if (result) {
            checked1 = document.getElementById('autoplay').checked;
            checked2 = document.getElementById('autoplaydontask').checked;
            let values = {};
            if (firebase.auth.currentUser) {
              firebase.auth.currentUser
                .getIdToken()
                .then((token) => {
                  if (checked2 && checked1) {
                    values.auto_play_serial_dont_ask = checked2;
                    values.auto_play_serial = checked1;
                  } else if (checked2 && !checked1) {
                    values.auto_play_serial_dont_ask = checked2;
                    values.auto_play_serial = checked1;
                  } else if (!checked2 && checked1) {
                    //session based
                    sessionStorage.setItem('auto_play_serial', true);
                  } else {
                    //session based
                    sessionStorage.setItem('auto_play_serial', false);
                  }
                  this.props.dispatch(updateUserFields(token, values));
                })
                .then(() => {
                  this.onRowClickDocument(row, true);
                });
            }
          }
        })
        .catch(() => {});
    } else if (isSinglePlay && row.documentType === 'full') {
      this.setState({ playSerial: true });
      this.props.dispatch(setDisableSkipAheadButton(false));
      this.props.dispatch(setDisableSkipBackButton(false));
      this.onRowClickDocument(row, true);
    } else {
      let id = row.id;
      let type = typeof id;
      this.props.dispatch(setPlaybackPlaylists({ documents: [] }));
      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setPlayerDocument(row));
      this.props.dispatch(setPlayingDocumentId(id));
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setShowSkipButton(showSkipButton));
      this.props.dispatch(setFeedUrl(row.feedUrl));
      this.props.dispatch(setStoreProgress(true));
      this.setState({
        playerKey: this.state.playerKey + 1,
        isNew: row.isNew
      });

      if (type === 'string' && id.startsWith('0')) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          const options = {
            method: 'POST',
            headers: { 'X-Firebase-Auth': token },
            url: `${config.serverURL}/documents`,
            data: { ...row, id: null }
          };

          let playerDocument = {};
          if (row.url !== null && row.url !== '') {
            axios(options)
              .then((result) => {
                let epi = result.data;
                playerDocument = {
                  document: {
                    name: epi.documentName,
                    url: epi.url
                  },
                  id: epi.id,
                  progress: epi.progress,
                  podcastId: epi.podcastId,
                  imgUrl: epi.imgUrl,
                  artistName: epi.artistName,
                  documentName: epi.documentName,
                  podcastName: epi.podcastName,
                  releaseDate: epi.releaseDate,
                  duration: epi.duration,
                  season: row.season,
                  showThumbs: row.showThumbs
                };
                this.props.dispatch(setPlayerDocument(playerDocument));
                this.props.dispatch(setPlayingDocumentId(epi.id.toString()));
                this.props.dispatch(setNewDocumentInLast5(true));
              })
              .catch(() => {
                this.setErrorHandler();
              });
          } else {
            let epi = row;
            playerDocument = {
              document: {
                name: epi.documentName,
                url: epi.url
              },
              id: epi.id,
              progress: epi.progress,
              podcastId: epi.podcastId,
              imgUrl: epi.imgUrl,
              artistName: epi.artistName,
              documentName: epi.documentName,
              podcastName: epi.podcastName,
              releaseDate: epi.releaseDate,
              duration: epi.duration,
              season: epi.season,
              showThumbs: row.showThumbs
            };
            this.props.dispatch(setPlayerDocument(playerDocument));
            this.props.dispatch(setPlayingDocumentId(id));
            this.props.dispatch(setNewDocumentInLast5(true));
          }
        });
      } else if (type === 'string' && !id.startsWith('0')) {
        this.props.dispatch(setPlayingDocumentId(parseInt(row.id, 10)));
      } else {
        this.props.dispatch(setPlayingDocumentId(row.id));
      }
    }
  };

  setErrorHandler = (err) => {
    this.setState({ error: err });

    this.interval = setTimeout(() => {
      if (this.state.error) this.setState({ error: null });
    }, 3000);
  };

  async fetchDocumentsOfPodcast(
    feedUrl,
    forceReload,
    season,
    reloadAll = false
  ) {
    this.props.dispatch(resetDiscoveryDocumentsPage());
    this.props.dispatch(resetDiscoveryDocumentsSearchValue());

    let allSeasons = [];
    if (this.props.playerDocument === '') {
      allSeasons = this.props.allSeasons !== null ? this.props.allSeasons : [];
    } else {
      allSeasons = this.props.podcastSeasons;
      this.props.dispatch(setAllSeasons(allSeasons));
    }
    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');

    if (indexForUnknownSeason !== -1 && indexForUnknownSeason + 1 === season) {
      season = config.unknownSeason;
    }

    if (feedUrl !== undefined && feedUrl !== null) {
      if (
        this.props.playerDocument === '' ||
        (typeof reloadAll === 'boolean' && reloadAll)
      ) {
        this.props.dispatch(setAllDocuments([]));
        this.props.dispatch(setFeedUrl(feedUrl));
      }
      this.setState({
        loader: true,
        fetchingDocuments: true
      });
      if (firebase.auth.currentUser) {
        try {
          const token = await firebase.auth.currentUser.getIdToken();
          const result = await fetchDocuments(
            token,
            this.props.feedUrl,
            this.props.podcastId,
            '',
            0,
            50,
            this.props.season,
            DocumentSortOptionsEnum.DEFAULT,
            undefined,
            undefined,
            this.state.isForceReloadEnabled
          );
          const documents = getDocumentsWithUniqueIdentifier(
            result.data.episodes
          );

          if (
            result.data.status === 'empty' ||
            result.data.status === 'error'
          ) {
            this.props.dispatch(setAllDocuments(documents));
            this.props.dispatch(setAllSeasons(result.data.allSeasons));
            this.props.dispatch(setPodcastSeasons(result.data.allSeasons));
            this.setState({
              loader: false,
              fetchingDocuments: false,
              podcastType: result.data.type,
              seasonCount: result.data.seasonCount,
              hasMoreDocuments: false
            });

            if (result.data.status === 'error') {
              this.setState({ isPodcastUnavailable: true });
            } else {
              this.setState({ hasMoreDocuments: false });
            }
          } else {
            if (documents.length === 0) {
              this.setState({ hasMoreDocuments: false });
            }
            const hasMoreDocuments = hasMoreDocumentsCheck(documents);

            this.setState({
              summary: result.data.podcastDescription,
              loader: false,
              fetchingDocuments: false,
              podcastType: result.data.type,
              seasonCount: result.data.seasonCount,
              hasMoreDocuments: hasMoreDocuments
            });

            this.props.dispatch(setAllDocuments(documents));
            this.props.dispatch(setPodcastSeasons(result.data.allSeasons));
            let arrayFull = getOnlyFullDocuments(documents);
            this.props.dispatch(setFullSerialDocuments(arrayFull));

            if (arrayFull.length > 0) {
              this.setState({ showPlayButton: true });
            } else {
              this.setState({ showPlayButton: false });
            }

            if (
              this.props.playerDocument === '' ||
              (typeof reloadAll === 'boolean' && reloadAll)
            ) {
              this.props.dispatch(setFullSerialDocuments(arrayFull));
              this.props.dispatch(setAllSeasons(result.data.allSeasons));
              if (this.state.playSerial) {
                this.props.dispatch(
                  setPlaybackPlaylists({
                    documents: this.props.fullDocuments
                  })
                );
              }
            }

            //reset dropdown
            if (document.getElementById('season-select')) {
              if (this.props.season && season === undefined) {
                if (this.state.seasonCount > 1) {
                  document.getElementById('season-select').value = '-1';
                } else {
                  document.getElementById('season-select').value = '1';
                }
              } else if (this.props.season && season !== undefined) {
                if (this.state.seasonCount > 1) {
                  if (season === config.unknownSeason) {
                    document.getElementById('season-select').value = '999';
                  } else {
                    document.getElementById('season-select').value = season;
                  }
                } else {
                  document.getElementById('season-select').value = '1';
                }
              }
            }

            if (
              (this.state.goToNextSeasonFromSeeAll || this.props.fromSkip) &&
              this.props.fullDocuments.length > 0
            ) {
              this.playDocuments();
            }

            if (
              this.state.playSerial &&
              !this.state.showPlayButton &&
              this.props.fullDocuments.length === 0
            ) {
              this.props.dispatch(setPlayerDocument(''));
            }
          }
        } catch (error) {
          console.error(error);
          this.props.dispatch(setAllDocuments([]));
          this.props.dispatch(setAllSeasons([]));
          this.props.dispatch(setPodcastSeasons([]));
          this.setState({
            loader: false,
            fetchingDocuments: false,
            podcastType: '',
            seasonCount: '0',
            isPodcastUnavailable: true,
            hasMoreDocuments: false
          });
        } finally {
          this.setState({ fetchingMoreDocuments: false });
        }
      }
    }
  }

  handleProgress = (document) => {
    let row = this.props.playerDocument;
    if (this.props.storeProgress) {
      if (this.props.newDocumentInLast5) {
        if (firebase.auth.currentUser) {
          firebase.auth.currentUser.getIdToken().then((token) => {
            this.props.dispatch(fetchLast5ListenedDocuments(token));
            this.props.dispatch(setNewDocumentInLast5(false));
          });
        }
      }
    }
    let playingDocumentId = this.props.playingDocumentId;
    if (typeof playingDocumentId === 'string') {
      playingDocumentId = parseInt(playingDocumentId, 10);
    }

    //const playingDocument = this.props.last5ListenedDocuments.find(e => e.id === playingDocumentId)
    const playingDocument = row;
    let completed = 0;
    if (playingDocument !== undefined) {
      completed = getProgress(
        playingDocument.progress,
        getDuration(playingDocument.duration)
      );
    }

    if (this.props.playbackPlaylist.length > 0) {
      if (!this.props.listeningToDocument) {
        if (playingDocument) {
          let playlistToPlay = this.props.playbackPlaylist;
          let documentName = playingDocument.documentName;
          let index = playlistToPlay.findIndex(
            (epi) => epi.documentName === documentName
          );
          if (index > -1) {
            if (playlistToPlay[index].id === null) {
              playlistToPlay[index].id = playingDocument.id;
            }
          }

          const documentIndex = playlistToPlay.findIndex(
            (epi) => epi.id === this.props.playingDocumentId
          );
          let indexInFullDocuments = 0;
          let fullDocuments = this.props.fullDocuments;
          indexInFullDocuments = fullDocuments.findIndex(
            (epi) => epi.id === this.props.playingDocumentId
          );
          if (
            completed >= 100 &&
            indexInFullDocuments < fullDocuments.length - 1
          ) {
            if (
              sessionStorage.getItem('auto_play_serial') === 'true' ||
              sessionStorage.getItem('auto_play_serial') === null
            ) {
              this.onPlayNextPlaylistDocument(
                fullDocuments[indexInFullDocuments + 1]
              );
            }
          } else if (completed >= 100 && this.state.goToNextSeason) {
            if (
              fullDocuments[indexInFullDocuments].season + 1 <=
              this.props.allSeasons.length
            ) {
              this.props.dispatch(
                setSeason(fullDocuments[indexInFullDocuments].season + 1)
              );
              this.onPlayNextPlaylistDocument();
            }
          }
        }
      }
    }
  };

  onLoadSeason = (season) => {
    this.fetchDocumentsOfPodcast(this.props.feedUrl, false, season, true);
  };

  onPlayNextPlaylistDocument = (document) => {
    if (document !== undefined) {
      let id = document.id;
      let type = typeof id;

      this.props.dispatch(setPlayingDocumentId(document.id));
      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setPlayerDocument(document));
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setFeedUrl(document.feedUrl));
      this.props.dispatch(setStoreProgress(true));
      this.setState({
        playerKey: this.state.playerKey + 1
      });
    } else {
      if (!this.state.selectSeason) {
        this.setState({ goToNextSeasonFromSeeAll: true });
      }
      this.fetchDocumentsOfPodcast(this.props.feedUrl, false, this.props.season);
    }
  };

  handleChange = () => {
    scrollToTop();
    this.props.dispatch(setDisableSkipBackButton(false));
    this.props.dispatch(setDisableSkipAheadButton(false));
    let season = this.season.value;
    this.setState({ selectSeason: season === -1 ? false : true });
    if (season === '-1') {
      this.props.dispatch(setSeason(undefined));
      this.fetchDocumentsOfPodcast(this.props.feedUrl, false, undefined);
    } else {
      this.props.dispatch(setSeason(season));
      this.fetchDocumentsOfPodcast(this.props.feedUrl, false, season);
    }
  };

  neverListenToPodcast = () => {
    let array = [];
    let documents = this.props.documents;
    if (documents && documents.length > 0) {
      array = documents.filter(function(epi) {
        return epi.progress !== 0 && epi.progress !== null;
      });
    }
    return array;
  };

  getOnlyFullDocuments = () => {
    let array = [];
    let allDocuments = this.props.documents;
    if (allDocuments && allDocuments.length > 0) {
      array = allDocuments.filter(function(epi) {
        return (
          epi.documentType === 'full' && epi.season !== config.unknownSeason
        );
      });
    }
    return array;
  };

  playDocuments = () => {
    var lastListenedIndex = 0;
    let documents = [];
    var lastListened = 0;
    let userFields = this.props.userFields;
    let checkedAutoPlay = userFields?.auto_play_serial
      ? 'checked'
      : 'unchecked';
    let checkedAutoPlayDontAsk = userFields?.auto_play_serial_dont_ask
      ? 'checked'
      : 'unchecked';
    this.props.dispatch(setDisableSkipAheadButton(false));
    this.props.dispatch(setDisableSkipBackButton(false));
    this.props.dispatch(resetProgress(false));
    this.props.dispatch(setFromSkip(false));
    this.setState({ goToNextSeason: false, goToNextSeasonFromSeeAll: false });
    if (this.props.playerDocument === '') {
      documents =
        this.props.fullDocuments !== null ? this.props.fullDocuments : [];
    } else {
      documents = this.getOnlyFullDocuments();
      this.props.dispatch(setFullSerialDocuments(documents));
    }

    if (documents && documents.length > 0) {
      let lastListened = Math.max(...documents.map((o) => o.timestampListened));
      let lastListenedIndex = documents.findIndex(
        (epi) => epi.timestampListened === lastListened
      );

      if (lastListenedIndex === -1) {
        lastListenedIndex = 0;
      }

      // Check if the autoplay dialog should be shown
      const shouldShowAutoPlayDialog =
        (userFields?.auto_play_serial_dont_ask === undefined ||
          !userFields?.auto_play_serial_dont_ask) &&
        (sessionStorage.getItem('auto_play_serial') === null ||
          sessionStorage.getItem('auto_play_serial') === 'false');

      if (shouldShowAutoPlayDialog) {
        swal({
          imageUrl: logo,
          title: '<div class="titleModal">Auto Play Mode</div>',
          html:
            '<p class="contentModal">Auto Play each document in order?<label class="switch">' +
            `<input type="checkbox" id="autoplay" name="autoplay" ${checkedAutoPlay}/>` +
            '<span class="slider round"></span>' +
            '</label></p>' +
            `<p><input type="checkbox" class="autoplay" id="autoplaydontask" name="autoplaydontask" ${checkedAutoPlayDontAsk}>` +
            '<label class="autoplaylabel" for="autoplaydontask" id="autoplaydontasklabel"> Do not ask again</label><br></p>',
          showCancelButton: true,
          showCloseButton: true,
          background: '#121C24',
          allowOutsideClick: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#E31690'
        })
          .then((result) => {
            if (result) {
              let checked1 = document.getElementById('autoplay').checked;
              let checked2 = document.getElementById('autoplaydontask').checked;
              let values = {};

              if (firebase.auth.currentUser) {
                firebase.auth.currentUser.getIdToken().then((token) => {
                  if (checked2) {
                    values.auto_play_serial_dont_ask = checked2;
                    values.auto_play_serial = checked1;
                  }

                  if (checked1) {
                    this.casesOfPlay(documents, lastListenedIndex);
                  } else {
                    sessionStorage.setItem('auto_play_serial', false);
                  }

                  this.props.dispatch(updateUserFields(token, values));
                });
              }
            }
          })
          .catch(() => {});
      } else {
        this.casesOfPlay(documents, lastListenedIndex);
      }
    }
  };

  casesOfPlay = (documents, lastListenedIndex) => {
    let lastListenedDocument = {};
    let completed = 0;
    let array = [];
    let lastDocumentOfSeason = {};
    let completedLastDocumentOfSeason = 0;
    let allSeasons = [];
    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');
    if (this.props.playerDocument === '') {
      allSeasons = this.props.allSeasons !== null ? this.props.allSeasons : [];
    } else {
      allSeasons =
        this.props.podcastSeasons !== null ? this.props.podcastSeasons : [];
      this.props.dispatch(setAllSeasons(allSeasons));
    }

    lastDocumentOfSeason = documents[documents.length - 1];
    completedLastDocumentOfSeason = getProgress(
      lastDocumentOfSeason.progress,
      getDuration(lastDocumentOfSeason.duration)
    );
    lastListenedDocument = documents[lastListenedIndex];
    array = documents.filter(function(epi) {
      return (
        epi.documentType === 'full' && epi.season === lastListenedDocument.season
      );
    });

    completed = getProgress(
      lastListenedDocument.progress,
      getDuration(lastListenedDocument.duration)
    );
    //if first document of first season disable button back
    if (
      lastListenedDocument.season === 1 &&
      array[0].id == lastListenedDocument.id
    ) {
      this.props.dispatch(setDisableSkipBackButton(true));
    }
    if (
      array[array.length - 1].id == lastListenedDocument.id &&
      ((indexForUnknownSeason !== -1 &&
        lastListenedDocument.season === allSeasons.length - 1) ||
        this.state.seasonCount === lastListenedDocument.season)
    ) {
      this.props.dispatch(setDisableSkipAheadButton(true));
    }
    if (
      array[array.length - 1].id === lastListenedDocument.id &&
      completed >= 100
    ) {
      if (
        (indexForUnknownSeason !== -1 &&
          lastListenedDocument.season === allSeasons.length - 1) ||
        this.state.seasonCount === lastListenedDocument.season
      ) {
        // Play the last document of the last season from the beginning
        this.props.dispatch(setDisableSkipAheadButton(true));
        this.props.dispatch(resetProgress(true));
        this.props.dispatch(setSeason(documents[lastListenedIndex].season));
        this.setState({ playSerial: true, goToNextSeason: false });

        this.fetchDocumentsOfPodcast(
          documents[lastListenedIndex].feedUrl,
          false,
          documents[lastListenedIndex].season,
          true
        );
        this.onRowClickDocument(documents[lastListenedIndex], true);
      } else {
        if (this.state.selectSeason) {
          swal({
            imageUrl: logo,
            title: '<div class="titleModal">Auto Play Mode</div>',
            html:
              '<p class="contentModal">It appears you have finished this season, do you want to restart?</p>',
            showCancelButton: true,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#E31690'
          }).then((result) => {
            if (result) {
              let values = {};
              if (firebase.auth.currentUser) {
                firebase.auth.currentUser.getIdToken().then((token) => {
                  documents.forEach((e) => {
                    if (
                      e.id !== null &&
                      e.progress !== null &&
                      e.progress !== 0
                    ) {
                      values.id = e.id;
                      values.progress = 0;
                      this.props.dispatch(updateDocument(token, values));
                    }
                  });
                });
              }
              this.props.dispatch(
                setSeason(documents[lastListenedIndex].season)
              );
              this.setState({ playSerial: true, goToNextSeason: false });

              this.fetchDocumentsOfPodcast(
                documents[0].feedUrl,
                false,
                documents[0].season
              );
              this.onRowClickDocument(documents[0], true);
            }
          });
        } else {
          this.props.dispatch(
            setSeason(documents[lastListenedIndex].season + 1)
          );
          this.setState({
            playSerial: true,
            goToNextSeason: false,
            goToNextSeasonFromSeeAll: true
          });

          this.fetchDocumentsOfPodcast(
            documents[lastListenedIndex].feedUrl,
            false,
            documents[lastListenedIndex].season + 1,
            true
          );
        }
      }
    } else if (
      array[array.length - 1].id === lastListenedDocument.id &&
      (completed < 100 || isNaN(completed))
    ) {
      // Continue playing last document and fetch next season
      if (
        (indexForUnknownSeason !== -1 &&
          lastListenedDocument.season === allSeasons.length - 1) ||
        this.state.seasonCount === lastListenedDocument.season ||
        lastListenedDocument.season === config.unknownSeason
      ) {
        this.setState({ goToNextSeason: false });
      } else {
        this.setState({ goToNextSeason: true });
      }

      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true });

      this.fetchDocumentsOfPodcast(
        documents[lastListenedIndex].feedUrl,
        false,
        documents[lastListenedIndex].season,
        true
      );
      this.onRowClickDocument(documents[lastListenedIndex], false, true);
    } else if (
      completedLastDocumentOfSeason < 100 ||
      isNaN(completedLastDocumentOfSeason)
    ) {
      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true, goToNextSeason: true });

      this.fetchDocumentsOfPodcast(
        documents[lastListenedIndex].feedUrl,
        false,
        documents[lastListenedIndex].season,
        true
      );
      this.onRowClickDocument(documents[lastListenedIndex], true);
    } else if (this.state.selectSeason) {
      swal({
        imageUrl: logo,
        title: '<div class="titleModal">Auto Play Mode</div>',
        html:
          '<p class="contentModal">It appears you have finished this season, do you want to restart?</p>',
        showCancelButton: true,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#E31690'
      }).then((result) => {
        if (result) {
          let values = {};
          if (firebase.auth.currentUser) {
            firebase.auth.currentUser.getIdToken().then((token) => {
              documents.forEach((e) => {
                if (e.id !== null && e.progress !== null && e.progress !== 0) {
                  values.id = e.id;
                  values.progress = 0;
                  this.props.dispatch(updateDocument(token, values));
                }
              });
            });
          }
          this.props.dispatch(setSeason(lastDocumentOfSeason.season));
          this.setState({ playSerial: true, goToNextSeason: false });

          this.fetchDocumentsOfPodcast(
            lastDocumentOfSeason.feedUrl,
            false,
            lastDocumentOfSeason.season,
            true
          );
          this.onRowClickDocument(lastDocumentOfSeason, true);
        }
      });
    } else {
      this.props.dispatch(resetProgress(true));
      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true, goToNextSeason: false });

      this.fetchDocumentsOfPodcast(
        lastDocumentOfSeason.feedUrl,
        false,
        lastDocumentOfSeason.season,
        true
      );
      this.onRowClickDocument(lastDocumentOfSeason, true);
    }
  };

  loadingMoreDocuments = async () => {
    if (!this.state.hasMoreDocuments || this.state.fetchingMoreDocuments) {
      return;
    }

    if (firebase.auth.currentUser) {
      this.setState({ fetchingMoreDocuments: true });
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const response = await fetchDocuments(
          token,
          this.props.feedUrl,
          this.props.podcast.podcastId,
          this.props.discoveryDocumentsSearchValue,
          this.props.discoveryDocumentsPage,
          DOCUMENTS_PAGE_SIZE,
          this.props.season,
          DocumentSortOptionsEnum.DEFAULT,
          undefined,
          undefined,
          false
        );

        const newDocuments = getDocumentsWithUniqueIdentifier(
          response.data.episodes
        );

        if (newDocuments.length === 0) {
          this.setState({ hasMoreDocuments: false });
        }

        const hasMoreDocuments = hasMoreDocumentsCheck(newDocuments);
        const updatedDocuments = [...this.props.documents, ...newDocuments];

        this.props.dispatch(setAllDocuments(updatedDocuments));
        this.props.dispatch(setPodcastSeasons(response.data.allSeasons));
        this.setState({ hasMoreDocuments: hasMoreDocuments });

        let arrayFull = this.getOnlyFullDocuments();
        if (arrayFull.length > 0) {
          this.setState({ showPlayButton: true });
        } else {
          this.setState({ showPlayButton: false });
        }

        if (this.props.playerDocument === '') {
          this.props.dispatch(
            setFullSerialDocuments(this.getOnlyFullDocuments())
          );
          this.props.dispatch(setAllSeasons(response.data.allSeasons));
          if (this.state.playSerial) {
            this.props.dispatch(
              setPlaybackPlaylists({
                documents: this.props.fullDocuments
              })
            );
          }
        }
      } catch (error) {
        console.error(error);
        this.setState({ hasMoreDocuments: false, isPodcastUnavailable: true });
      } finally {
        this.props.dispatch(increaseDiscoveryDocumentsPage());
        this.setState({ fetchingMoreDocuments: false });
      }
    }
  };

  searchDocuments = async () => {
    if (this.state.fetchingMoreDocuments) {
      return;
    }

    if (firebase.auth.currentUser) {
      this.setState({ fetchingMoreDocuments: true });
      this.props.dispatch(resetDiscoveryDocumentsPage());
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const response = await fetchDocuments(
          token,
          this.props.feedUrl,
          this.props.podcast.podcastId,
          this.props.discoveryDocumentsSearchValue,
          0,
          DOCUMENTS_PAGE_SIZE,
          this.props.season,
          DocumentSortOptionsEnum.DEFAULT,
          undefined,
          undefined,
          false
        );

        const newDocuments = getDocumentsWithUniqueIdentifier(
          response.data.episodes
        );
        const hasMoreDocuments = hasMoreDocumentsCheck(newDocuments);

        this.props.dispatch(setAllDocuments(newDocuments));
        this.props.dispatch(setPodcastSeasons(response.data.allSeasons));
        this.setState({ hasMoreDocuments: hasMoreDocuments });

        let arrayFull = this.getOnlyFullDocuments();
        if (arrayFull.length > 0) {
          this.setState({ showPlayButton: true });
        } else {
          this.setState({ showPlayButton: false });
        }

        if (this.props.playerDocument === '') {
          this.props.dispatch(
            setFullSerialDocuments(this.getOnlyFullDocuments())
          );
          this.props.dispatch(setAllSeasons(response.data.allSeasons));
          if (this.state.playSerial) {
            this.props.dispatch(
              setPlaybackPlaylists({
                documents: this.props.fullDocuments
              })
            );
          }
        }
      } catch (error) {
        console.error(error);
        this.setState({ hasMoreDocuments: false, isPodcastUnavailable: true });
      } finally {
        this.setState({ fetchingMoreDocuments: false });
      }
    }
  };

  render() {
    const category = this.props.category;
    let userFields = this.props.userFields;
    let documents = this.props.documents !== null ? this.props.documents : [];
    let podcastSeasons =
      this.props.podcastSeasons !== null ? this.props.podcastSeasons : [];

    return (
      <div style={{ margin: '30px' }}>
        <div className="square-container">
          <Button
            bsClass="button-oval button-signin24 button-cta2-24 button-width24"
            onClick={this.props.goBack}
          >
            <i
              className="fa fa-chevron-left"
              style={{ marginRight: '5px' }}
            ></i>
            Back
          </Button>
        </div>
        {this.state.fetchingDocuments && (
          <>
            <PodcastDocumentHeaderLoader />
            <TablePodcastSkeletonLoader />
          </>
        )}
        {!this.state.fetchingDocuments && (
          <>
            <div
              className="square-container-header"
              style={{ marginTop: '15px' }}
            >
              {this.props.podcastId ? (
                <>
                  <div className="img-square-container-header">
                    <Row>
                      <Col
                        style={{
                          float: 'left',
                          paddingLeft: '15px',
                          paddingRight: '15px'
                        }}
                      >
                        <div>
                          <img
                            src={
                              this.props.imgUrl
                                ? this.props.imgUrl
                                : imageNotAvailable
                            }
                            width="200px"
                            height="200px"
                          />
                        </div>
                        <div style={{ textAlign: 'left', fontSize: '15px' }}>
                          <i
                            className="fa fa-tag"
                            style={{ marginRight: '5px' }}
                          ></i>
                          {category}
                        </div>
                      </Col>
                      <Col>
                        <div>
                          {this.props.name}
                          {documents.length > 0 && documents[0].subscribed && (
                            <Button
                              bsClass="button-oval button-signin24 button-cta2-24 button-width24"
                              onClick={this.props.onClick}
                              id="un-sub"
                              style={{ marginRight: 20, float: 'right' }}
                            >
                              Unsubscribe
                            </Button>
                          )}
                        </div>
                        <div className="artist-name">{this.props.artist}</div>
                        <div>
                          {documents.length > 0 && !documents[0].subscribed ? (
                            <Button
                              bsClass="button-oval button-signin24 button-cta-24 button-width24"
                              onClick={this.props.onClick}
                              id="un-sub"
                              style={{ marginTop: 12, marginBottom: 12 }}
                            >
                              {documents.length > 0 && documents[0].subscribed
                                ? 'Unsubscribe'
                                : 'Subscribe'}
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                        <ShowMoreText
                          lines={2}
                          more={
                            <i
                              className="fa fa-chevron-down"
                              style={{ color: 'rgb(77, 77, 79)' }}
                            ></i>
                          }
                          less={
                            <i
                              className="fa fa-chevron-up"
                              style={{ color: 'rgb(77, 77, 79)' }}
                            ></i>
                          }
                          className="show-more"
                          expanded={false}
                          truncatedEndingComponent={'... '}
                        >
                          {this.props.summary && this.props.summary !== ''
                            ? this.props.summary
                            : documents.length > 0
                            ? this.state.summary
                            : ''}
                        </ShowMoreText>
                      </Col>
                    </Row>
                  </div>
                </>
              ) : (
                ''
              )}
            </div>

            <div
              style={{ marginTop: '10px' }}
              className="borderlessDocumentsTable"
            >
              <div className="document-name">
                Documents for '{this.props.name}'
              </div>

              {this.state.isPodcastUnavailable ? (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '25px', fontWeight: '600' }}>
                    This podcast is currently unavailable.
                  </div>
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    {this.state.podcastType === 'serial' ? (
                      <div>
                        <FormGroup>
                          <ControlLabel className="seasonsLabel">
                            Seasons
                          </ControlLabel>
                          <FormControl
                            id="season-select"
                            componentClass="select"
                            className="selectSeason"
                            inputRef={(el) => (this.season = el)}
                            onChange={this.handleChange}
                          >
                            {this.state.seasonCount === 1 ? (
                              ''
                            ) : (
                              <option value="-1">See everything...</option>
                            )}
                            {podcastSeasons.length > 0
                              ? podcastSeasons.map((e, i) => {
                                  return (
                                    <option
                                      key={i + 1}
                                      value={
                                        e !== 'Unknown'
                                          ? e.substring(7, e.length)
                                          : config.unknownSeason
                                      }
                                    >
                                      {e}
                                    </option>
                                  );
                                })
                              : ''}
                          </FormControl>
                          {this.state.showPlayButton &&
                          (((userFields?.auto_play_serial_dont_ask ===
                            undefined ||
                            !userFields?.auto_play_serial_dont_ask) &&
                            (sessionStorage.getItem('auto_play_serial') ===
                              null ||
                              sessionStorage.getItem('auto_play_serial') ===
                                'true')) ||
                            (userFields?.auto_play_serial_dont_ask &&
                              userFields?.auto_play_serial) ||
                            (userFields?.auto_play_serial_dont_ask &&
                              (userFields?.auto_play_serial === undefined ||
                                !userFields?.auto_play_serial) &&
                              sessionStorage.getItem('auto_play_serial') ===
                                'true')) ? (
                            <Button
                              bsClass="custom-button-play"
                              onClick={this.playDocuments}
                            >
                              {this.neverListenToPodcast() &&
                              this.neverListenToPodcast().length > 0
                                ? 'Resume Season Playback'
                                : 'Start Season Playback'}
                            </Button>
                          ) : (
                            ''
                          )}
                        </FormGroup>
                      </div>
                    ) : (
                      <div style={{ flex: 1 }} />
                    )}
                    <div style={{ marginTop: '30px' }}>
                      <RefreshButton
                        onClick={() => {
                          this.setState({ isForceReloadEnabled: true });
                          this.fetchDocumentsOfPodcast(
                            this.props.feedUrl,
                            true,
                            this.props.season,
                            true
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '40px' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'right',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <Input
                        placeholder="Search"
                        style={{ width: '25%' }}
                        onChange={(e) => {
                          this.props.dispatch(
                            updateDiscoveryDocumentsSearchValue(e.target.value)
                          );
                          this.debouncedSearch();
                        }}
                      />
                    </div>
                    <InfiniteScrollWrapper
                      dataLength={documents.length}
                      next={this.loadingMoreDocuments}
                      hasMore={this.state.hasMoreDocuments}
                      scrollThreshold={0.6}
                    >
                      <BootstrapTable
                        keyField="documentName"
                        data={documents}
                        striped={false}
                        bordered={false}
                        hover={true}
                      >
                        <TableHeaderColumn dataField="id" hidden={true}>
                          ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="season" hidden={true}>
                          Season
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="documentName"
                          hidden={true}
                        >
                          Name
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="imgUrl"
                          dataSort={false}
                          width="80"
                          dataFormat={this.formatHeaderdocumentab}
                        ></TableHeaderColumn>
                        <TableHeaderColumn
                          width="250"
                          dataField=""
                          dataFormat={this.formatdocumentab}
                          tdStyle={{
                            whiteSpace: 'normal'
                          }}
                          dataSort={true}
                          sortFunc={this.sortByName}
                        >
                          Document Name
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          width="100"
                          dataField="releaseDate"
                          sortFunc={this.sortDatedocumentab}
                          dataSort={true}
                        >
                          Pub. Date
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          width="100"
                          dataField="document"
                          dataFormat={this.formatAdddocumentoPlaylist}
                        >
                          Add to playlist
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          width="400"
                          dataField="description"
                          dataFormat={(cell) => (
                            <div>
                              {' '}
                              {cell && cell.length > 20 ? (
                                <OverlayTrigger
                                  trigger={['hover', 'focus']}
                                  placement="bottom"
                                  overlay={
                                    <Popover id="popover-basic">{cell}</Popover>
                                  }
                                >
                                  <Truncate lines={3} ellipsis={'...'}>
                                    {cell}
                                  </Truncate>
                                </OverlayTrigger>
                              ) : (
                                cell
                              )}
                            </div>
                          )}
                        >
                          {' '}
                          Description
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="showThumbs"
                          hidden={true}
                        />
                      </BootstrapTable>
                    </InfiniteScrollWrapper>

                    <div style={{ height: '20px' }}></div>
                    <div style={{ height: '20px' }}></div>
                    <div style={{ height: '20px' }}></div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {this.state.addToPlaylist && (
          <AddToPlaylistModal
            title="Add document to playlist"
            show={this.state.addToPlaylist}
            onClose={() => this.addToPlaylistHandler(false, null)}
            documentoAdd={this.state.documentoAdd}
            parentCallback={this.doNothing}
          />
        )}
        <div style={{ height: '20px' }}></div>
        <div style={{ height: '20px' }}></div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    userFields: store.app.userFields,
    playbackPlaylist: store.app.playbackPlaylist,
    playingDocumentId: store.app.playingDocumentId,
    last5ListenedDocuments: store.app.last5ListenedDocuments,
    listeningToDocument: store.app.listeningToDocument,
    playerDocument: store.player.playerDocument,
    forward: store.player.forward,
    backward: store.player.backward,
    isPaused: store.player.isPaused,
    documents: store.player.allDocuments,
    fullDocuments: store.player.fullDocuments,
    allSeasons: store.player.allSeasons,
    fromPlaylistTab: store.player.fromPlaylistTab,
    storeProgress: store.player.storeProgress,
    feedUrl: store.player.feedUrl,
    newDocumentInLast5: store.player.newDocumentInLast5,
    season: store.player.season,
    fromSkip: store.player.fromSkip,
    podcastSeasons: store.player.podcastSeasons,
    discoveryDocumentsPage: store.app.discoveryDocumentsPage,
    discoveryDocumentsSearchValue: store.app.discoveryDocumentsSearchValue
  };
};

export default connect(mapStateToProps)(PodcastWithDocuments);
